var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinMiddleMarkerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 79,
    viewBox: "0 0 60 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.2471,
    r: 30,
    fill: "#F6A72D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9338 17.6699C22.7699 17.6699 21.6862 20.2862 23.2163 21.8164C23.6718 22.2719 23.9277 22.8897 23.9277 23.5339L23.9277 26.3795C23.9277 27.0237 23.6718 27.6415 23.2163 28.097C21.6861 29.6272 22.7699 32.2435 24.9338 32.2434L29.1061 32.2434L29.1061 41.9313C29.1061 42.425 29.5063 42.8252 30 42.8252C30.4937 42.8252 30.8939 42.425 30.8939 41.9313V32.2434L35.0662 32.2434C37.2301 32.2434 38.3138 29.6271 36.7837 28.097C36.3282 27.6415 36.0723 27.0237 36.0723 26.3795L36.0723 23.5338C36.0723 22.8897 36.3282 22.2719 36.7837 21.8163C38.3139 20.2862 37.2301 17.6699 35.0662 17.6699L24.9338 17.6699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4661 65.6137C31.2714 67.279 28.7957 67.2828 27.596 65.6211L22.1838 58.1246C20.7513 56.1405 22.169 53.3685 24.6161 53.3685L35.4059 53.3685C37.8488 53.3685 39.2675 56.1322 37.8436 58.1171L32.4661 65.6137Z",
    fill: "#F6A72D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1826 71.7626C29.4399 70.9709 30.5601 70.9709 30.8174 71.7626C30.9324 72.1167 31.2624 72.3565 31.6347 72.3565C32.4673 72.3565 32.8134 73.4218 32.1399 73.9112C31.8387 74.1301 31.7126 74.518 31.8277 74.8721C32.0849 75.6639 31.1787 76.3223 30.5052 75.8329C30.2039 75.6141 29.7961 75.6141 29.4948 75.8329C28.8213 76.3223 27.9151 75.6639 28.1723 74.8721C28.2874 74.518 28.1613 74.1301 27.8601 73.9112C27.1866 73.4218 27.5327 72.3565 28.3653 72.3565C28.7376 72.3565 29.0676 72.1167 29.1826 71.7626Z",
    fill: "#F6A72D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMiddleMarkerIcon);
export default __webpack_public_path__ + "static/media/pinMiddleMarkerIcon.b5ed4ba07fe7ef53d64a8add39073e04.svg";
export { ForwardRef as ReactComponent };